import React, { useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useRecorder } from 'react-microphone-recorder';

function MicRecorder({ onAudioURLChange, showStockButton = false, onShowStock }) {
  const { 
    audioLevel, 
    startRecording, 
    pauseRecording, 
    stopRecording, 
    resetRecording, 
    timeElapsed, 
    audioURL, 
    isRecording 
  } = useRecorder();

  // Update parent component when audioURL changes
  useEffect(() => {
    if (audioURL && typeof onAudioURLChange === 'function') {
      onAudioURLChange(audioURL);
    }
  }, [audioURL, onAudioURLChange]);

  function toggleRecording() {
    if (isRecording) {
      stopRecording();
    } else {
      startRecording();
    }
  }

  // Convert the normalized audioLevel (0 - 1) to a percentage (0 - 100)
  const amplitudePercentage = Math.min(audioLevel * 1, 100);

  return (
    <Container className="mt-4">
      {/* Custom Amplitude Bar */}
      <Row className="mb-3">
        <Col>
          <div
            style={{
              height: '20px',
              backgroundColor: '#eee',
              borderRadius: '10px',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                height: '100%',
                width: `${amplitudePercentage}%`,
                backgroundColor: '#76c7c0',
                transition: 'none',
              }}
            />
          </div>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col>
          <div className="d-flex justify-content-between align-items-center desktop-recording-layout">
            <div>
              <Button 
                variant={ isRecording ? "danger" : "primary" }
                onClick={toggleRecording} 
                className="mx-1 btn-voice-recording"
              >
                { isRecording && "Stop Recording" }
                { !isRecording && "Start Recording" }
              </Button>
              
              {/* Stock Voice Button */}
              {showStockButton && onShowStock && (
                <Button 
                  variant="outline-secondary" 
                  onClick={onShowStock}
                  className="mx-1 btn-voice-stock"
                >
                  I don't want to clone my voice
                </Button>
              )}
            </div>
            <div>
              <p className="mb-0">Recording Time: {timeElapsed}s</p>
            </div>
          </div>
          
          {/* Mobile layout - recording time between buttons */}
          <div className="mobile-recording-layout">
            <div className="d-flex justify-content-center mb-2">
              <Button 
                variant={ isRecording ? "danger" : "primary" }
                onClick={toggleRecording} 
                className="btn-voice-recording"
              >
                { isRecording && "Stop Recording" }
                { !isRecording && "Start Recording" }
              </Button>
            </div>
            
            <div className="text-center mb-2">
              <p className="mb-0">Recording Time: {timeElapsed}s</p>
            </div>
            
            {/* Stock Voice Button */}
            {showStockButton && onShowStock && (
              <div className="d-flex justify-content-center">
                <Button 
                  variant="outline-secondary" 
                  onClick={onShowStock}
                  className="btn-voice-stock"
                >
                  I don't want to clone my voice
                </Button>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default MicRecorder;
